import _ from 'lodash'
import { mergeGridRows } from './widgets/mergeGridRows'
import { widgetIsCompatible } from './widgets/widgetIsCompatible'

export function usePlotArea(dashboardJson: any): boolean {
    try {
        if (!dashboardJson || !Array.isArray(dashboardJson?.widgets)) return false

        const widgets = dashboardJson?.widgets

        const gridDash = dashboardJson?.jsonConfig?.layoutModes?.desktop?.grid

        const widgetsVerticalIds = widgets
            .filter(widget => widgetIsCompatible(widget))
            .map(({ id }) => String(id)) as string[]

        const normalizeGrid = _.sortBy(
            Object.entries(gridDash).reduce(
                (state, [id, grid]) => [
                    ...state,
                    {
                        ...grid,
                        id: parseInt(id)
                    }
                ],
                []
            ),
            'col'
        )

        const widgetsByRowVertical = mergeGridRows(
            _.groupBy(
                normalizeGrid.filter(({ id }) => widgetsVerticalIds.includes(String(id))),
                'row'
            )
        )

        if (Object.keys(widgetsByRowVertical).length == 1) {
            return widgets.some(widget => widgetIsCompatible(widget))
        }
        return false
    } catch (e) {
        return false
    }
}
